module.exports = __webpack_public_path__ + "static/media/trophy-mtn-retro.533dbfe5.png";